module.exports = __webpack_public_path__ + "img/login.8f9bdf6b.jpg";